import { IUserProfile } from 'data/entities/userprofile.entity';
import { userProfilesRepository } from 'data/repositories/userprofile.repository';

export const getUserProfile = async (): Promise<IUserProfile | null> => {
    try {
        const userProfile = await userProfilesRepository.getUserProfile();
        if (!userProfile) throw Error('User Porfile not found!');

        return userProfile;
    } catch (message) {
        return null;
    }
};
